import React from 'react';
import { IconProps } from './icon.types';

function IconSMS(props: IconProps) {
  const { customClassName = '', customStyle = {} } = props;

  return (
    <svg
      className={customClassName}
      style={customStyle}
      width="30"
      height="31"
      viewBox="0 0 30 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.7453 0.138524L3.89022 5.60188C-1.33145 6.90688 -1.2798 14.3469 3.9602 15.5802L10.7587 17.1802C10.927 17.2202 11.1054 17.1702 11.2271 17.0469L19.1238 9.15021C19.6071 8.66688 20.4068 8.66688 20.8901 9.15021C21.3735 9.63354 21.3735 10.4335 20.8901 10.9169L12.9902 18.8169C12.8685 18.9385 12.8171 19.1169 12.8571 19.2852L14.4554 26.0769C15.6887 31.3169 23.1284 31.3685 24.4334 26.1469L29.8969 4.29186C30.5219 1.78186 28.2503 -0.488143 25.7453 0.138524Z"
        fill="#3F1887"
      />
    </svg>
  );
}

export default IconSMS;
